import React  from 'react';

export const HeadLine = (props) => {
    return(
        <div className="headLine">
            <h1>{props.headline}</h1>
            <div className="line">
                <img src="img/LineYelou.jpg" alt=""/>
            </div>
        </div>
    )
}

